import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Wenhaozi"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_627_8424)"><path d="M8.00016 14.6667C9.8411 14.6667 11.5078 13.9205 12.7142 12.7141C13.9206 11.5076 14.6668 9.84097 14.6668 8.00004C14.6668 6.15911 13.9206 4.49244 12.7142 3.28599C11.5078 2.07957 9.8411 1.33337 8.00016 1.33337C6.15923 1.33337 4.49256 2.07957 3.28612 3.28599C2.07969 4.49244 1.3335 6.15911 1.3335 8.00004C1.3335 9.84097 2.07969 11.5076 3.28612 12.7141C4.49256 13.9205 6.15923 14.6667 8.00016 14.6667Z" stroke="#7E57EE" stroke-width="1.33333"></path><path d="M8 9.54159V8.20825C9.10457 8.20825 10 7.31282 10 6.20825C10 5.10369 9.10457 4.20825 8 4.20825C6.89543 4.20825 6 5.10369 6 6.20825" stroke="#7E57EE" stroke-width="1.33333" stroke-linecap="square"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99984 12.5415C8.46007 12.5415 8.83317 12.1684 8.83317 11.7082C8.83317 11.248 8.46007 10.8749 7.99984 10.8749C7.5396 10.8749 7.1665 11.248 7.1665 11.7082C7.1665 12.1684 7.5396 12.5415 7.99984 12.5415Z" fill="#7E57EE"></path></g><defs><clipPath id="clip0_627_8424"><rect width="16" height="16" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var wenhaozi = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { wenhaozi as default };
